import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import {
  cancelBusinessInfoModalDialog,
  closeBusinessInfoModalDialog,
  resetBusinessInfoModalDialog,
  saveChangesBusinessInfoModalDialog,
  validateBusinessInfoModalDialog,
} from '../../actions/business_info_modal_dialog'
import BusinessInfoForm from './business_info_form'
import { fetchBusinessById } from '../../actions/business'

class BusinessInfoModalDialog extends PureComponent {
  handleCloseModal() {
    const { fetchBusinessById, closeBusinessInfoModalDialog, data } = this.props
    fetchBusinessById(data.id)
    closeBusinessInfoModalDialog()
  }

  render() {
    const { isModalDialogOpen, cancelBusinessInfoModalDialog, isChangesSaved, data } = this.props
    const onHide = isChangesSaved ? () => this.handleCloseModal() : cancelBusinessInfoModalDialog

    return (
      <Modal show={isModalDialogOpen} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Business Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BusinessInfoForm data={data} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  isChangesSaved: state.businessInfoModalDialog.isChangesSaved,
  isValidated: state.businessInfoModalDialog.isValidated,
  newData: state.businessInfoModalDialog.newData,
  isModalDialogOpen: state.businessInfoModalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeBusinessInfoModalDialog,
      cancelBusinessInfoModalDialog,
      saveChangesBusinessInfoModalDialog,
      validateBusinessInfoModalDialog,
      resetBusinessInfoModalDialog,
      fetchBusinessById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BusinessInfoModalDialog))
